import { B300, DN90, G300, G500, N300, P100, P200, R100, R500, T200, Y300, Y500 } from '@atlaskit/theme/colors';
export const chartColors = [P200, G300, R100, T200, N300, G500, B300, Y300, P100, R500, Y500, DN90];
export const reasonKeyToContent = {
  alternative: {
    name: 'Alternative',
    tooltip: 'I found a better alternative for this app'
  },
  appDesign: {
    name: 'Design',
    tooltip: 'App Design'
  },
  appFunctionality: {
    name: 'Functionality',
    tooltip: 'App functionality'
  },
  competitor: {
    name: 'Competitor',
    tooltip: 'We are moving to a different solution'
  },
  covid: {
    name: 'Covid',
    tooltip: 'Financially affected by covid'
  },
  customerSupport: {
    name: 'Support',
    tooltip: 'Customer Support'
  },
  disable: {
    name: 'Disabled'
  },
  expectations: {
    name: 'Expectations',
    tooltip: 'The app did not meet my expectations'
  },
  expensive: {
    name: 'Expensive',
    tooltip: 'App is expensive'
  },
  merging: {
    name: 'Merging',
    tooltip: 'Merging with another instance'
  },
  migrate: {
    name: 'Moving',
    tooltip: 'We are moving to another cloud platform'
  },
  'moving-to-server-or-dc': {
    name: 'Server / DC',
    tooltip: 'Moving to Server/Datacenter'
  },
  'org-change': {
    name: 'Org closed',
    tooltip: 'Org closed down'
  },
  other: {
    name: 'Other'
  },
  'post-evaluation': {
    name: 'Evaluation',
    tooltip: 'We were still evaluating the product but decided to deactivate'
  },
  'product-experience': {
    name: 'Experience',
    tooltip: 'Product experience not good'
  },
  resetting: {
    name: 'Resetting',
    tooltip: 'We are resetting/starting fresh with this instance'
  },
  sandbox: {
    name: 'Sandbox',
    tooltip: 'Used for testing/sandbox'
  },
  skipped: {
    name: 'Not needed',
    tooltip: 'Not needed anymore'
  },
  uninstall: {
    name: 'Uninstalled'
  },
  unsubscribe: {
    name: 'Unsubscribed'
  },
  bugs: {
    name: 'Bugs'
  },
  cost: {
    name: 'Expensive',
    tooltip: 'Too Expensive'
  },
  functionality: {
    name: 'Functionality'
  },
  interface: {
    name: 'Confusing',
    tooltip: 'Confusing interface'
  },
  restarting: {
    name: 'Restarting',
    tooltip: 'Restarting Instance'
  },
  usefulness: {
    name: 'Not useful'
  }
};